import {TriangleDownIcon} from '@primer/octicons-react'
import {Stack, Token} from '@primer/react'
import type {ComponentProps, ComponentType, RefObject} from 'react'

import styles from './AgentTasksToken.module.css'
import {TASK_NOUN} from '../utils/constants'

type AgentTasksTokenProps = {
  icon: ComponentType
  iconColor: string
  label: string
  onClick?: ComponentProps<typeof Token>['onClick']
  isSticky?: boolean
  buttonRef?: RefObject<HTMLElement | null>
}

export function AgentTasksToken({
  icon: Icon,
  iconColor,
  label,
  onClick,
  isSticky,
  buttonRef,
  ...props
}: AgentTasksTokenProps) {
  // In sticky mode, render as plain text styled button (no token/caret)
  if (isSticky) {
    return (
      <button
        ref={buttonRef as RefObject<HTMLButtonElement>}
        aria-label={`Agent ${TASK_NOUN}s: ${label}`}
        className={styles.stickyText}
        onClick={onClick}
        {...props}
      >
        <span className={styles.stickyIcon} style={{color: iconColor}} aria-hidden="true">
          <Icon />
        </span>
        {label}
      </button>
    )
  }

  return (
    <Token
      ref={buttonRef}
      as="button"
      aria-label={`Agent ${TASK_NOUN}s: ${label}`}
      className={styles.token}
      text={
        <Stack direction="horizontal" align="center" className={styles.tokenContent}>
          <span style={{color: iconColor}} aria-hidden="true">
            <Icon />
          </span>
          <span>{label}</span>
          <span className={styles.tokenCaret} aria-hidden="true">
            <TriangleDownIcon size={16} />
          </span>
        </Stack>
      }
      size="xlarge"
      onClick={onClick}
      {...props}
    />
  )
}
